export var CapitalActionEntryType;
(function (CapitalActionEntryType) {
    CapitalActionEntryType["Expense"] = "expense";
    CapitalActionEntryType["Investment"] = "investment";
    CapitalActionEntryType["GeneralCapitalCall"] = "general-capital-call";
    CapitalActionEntryType["AdvanceSubscriptionPayment"] = "advance-subscription-payment";
    CapitalActionEntryType["CapitalContributionCall"] = "capitalContributionCall";
    CapitalActionEntryType["Fees"] = "fees";
    CapitalActionEntryType["CapitalRefund"] = "capital-refund";
    CapitalActionEntryType["CapitalDistribution"] = "capital-distribution";
    CapitalActionEntryType["Equalisation"] = "equalisation";
})(CapitalActionEntryType || (CapitalActionEntryType = {}));
export var DrawdownSourcePriority;
(function (DrawdownSourcePriority) {
    DrawdownSourcePriority["UnallocatedCommitmentFirst"] = "unallocated-commitment-first";
    DrawdownSourcePriority["RecallableDistributionFirst"] = "recallable-distribution-first";
    DrawdownSourcePriority["Manual"] = "manual";
})(DrawdownSourcePriority || (DrawdownSourcePriority = {}));
export var CapitalActionTypes;
(function (CapitalActionTypes) {
    CapitalActionTypes["CapitalActionCreated"] = "capitalActionCreated";
})(CapitalActionTypes || (CapitalActionTypes = {}));
export var CapitalActionTransactionSubType;
(function (CapitalActionTransactionSubType) {
    CapitalActionTransactionSubType["ExpensesCall"] = "expensesCall";
    CapitalActionTransactionSubType["InvestmentCall"] = "investmentCall";
    CapitalActionTransactionSubType["GeneralCapitalCall"] = "generalCapitalCall";
    CapitalActionTransactionSubType["AdvanceSubscriptionCall"] = "advanceSubscriptionCall";
    CapitalActionTransactionSubType["AdvanceSubscriptionUsed"] = "advanceSubscriptionUsed";
    CapitalActionTransactionSubType["CapitalContributionCall"] = "capitalContributionCall";
    CapitalActionTransactionSubType["FeesCall"] = "feesCall";
    CapitalActionTransactionSubType["CapitalRefund"] = "capitalRefund";
    CapitalActionTransactionSubType["RecallableReturnOfCapital"] = "recallableReturnOfCapital";
    CapitalActionTransactionSubType["NonRecallableReturnOfCapital"] = "nonRecallableReturnOfCapital";
    CapitalActionTransactionSubType["RecallableIncome"] = "recallableIncome";
    CapitalActionTransactionSubType["NonRecallableIncome"] = "nonRecallableIncome";
    CapitalActionTransactionSubType["RecallableDistributionOutsideOfCarry"] = "recallableDistributionOutsideOfCarry";
    CapitalActionTransactionSubType["NonRecallableDistributionOutsideOfCarry"] = "nonRecallableDistributionOutsideOfCarry";
    CapitalActionTransactionSubType["CarriedInterest"] = "carriedInterest";
    CapitalActionTransactionSubType["CallReceivable"] = "callReceivable";
    CapitalActionTransactionSubType["DistributionsPayable"] = "distributionsPayable";
    CapitalActionTransactionSubType["CarriedInterestPayable"] = "carriedInterestPayable";
    CapitalActionTransactionSubType["EqualisationCall"] = "equalisationCall";
    CapitalActionTransactionSubType["EqualisationRefund"] = "equalisationRefund";
    CapitalActionTransactionSubType["EqualisationInterestPaidIn"] = "equalisationInterestPaidIn";
    CapitalActionTransactionSubType["EqualisationInterestPaidOut"] = "equalisationInterestPaidOut";
})(CapitalActionTransactionSubType || (CapitalActionTransactionSubType = {}));
//# sourceMappingURL=index.js.map